/**
 * Table cell that renders a notes affordance for opening a row-scoped side panel.
 */
import NotesIcon from "../../../../svg/notes-icon";

/**
 * Renders a centered notes icon control for table rows (e.g. CMM orders).
 *
 * @returns Notes trigger markup (no row click side effects beyond the parent `td` handler).
 */
const NotesIconCell = () => {
  return (
    <div className="flex justify-center">
      <button
        type="button"
        className="flex cursor-pointer items-center justify-center rounded border-none bg-transparent p-1 hover:bg-primaryGray-16"
        aria-label="Open order notes"
      >
        <NotesIcon />
      </button>
    </div>
  );
};

export default NotesIconCell;
